import { render, staticRenderFns } from "./ResultI.vue?vue&type=template&id=1ae5727e&"
import script from "./ResultI.vue?vue&type=script&lang=js&"
export * from "./ResultI.vue?vue&type=script&lang=js&"
import style0 from "./ResultI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports